import { Injectable } from "@angular/core";
import { Model } from "src/logic/model";

/**вывод сообщений */
@Injectable({
  providedIn: 'root'
})
export class Messages {

  constructor(private model: Model) {
    setInterval(() => {
      if (this.model.messages().length === 0)
        return;
      let hasMessages = false;
      for (let i = 0; i < this.model.messages().length; i++) {
        let m: MessagesItem = this.model.messages()[i];
        if (!m.removed) {
          if ((new Date()).getTime() - m.date.getTime() > 2000) {
            m.removed = true;
          }
          else {
            hasMessages = true;
          }
        }
      }
      if (!hasMessages) {
        setTimeout(() => {
          if (this.model.messages().every((m) => m.removed))
            this.model.messages().length = 0;
        },700);
      }
    }, 1000);
  }

  add(text: string, messageType: MessageTypeEnum = MessageTypeEnum.Info) {
    this.model.messages.update(values => [...values, new MessagesItem(text, messageType)]);
  }
}

export class MessagesItem {
  text: string = '';
  date: Date = new Date();
  messageType: MessageTypeEnum = MessageTypeEnum.Info;
  removed: boolean = false;

  constructor(text: string, messageType: MessageTypeEnum) {
    this.text = text;
    this.messageType = messageType;
  }
}

export enum MessageTypeEnum {
  Info,
  Success,
  Error
}
